import { render, staticRenderFns } from "./BagSlotOptionPopup.vue?vue&type=template&id=0b82458d&scoped=true&"
import script from "./BagSlotOptionPopup.vue?vue&type=script&lang=js&"
export * from "./BagSlotOptionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82458d",
  null
  
)

export default component.exports